import { Controller } from '@hotwired/stimulus'
import { i18n } from '../lib/i18n'

/**
 * Field Preview Controller
 * Fetches and displays sample data for a field expression
 */
export default class extends Controller {
  static targets = ['expression', 'panel', 'previewButton']
  static values = { url: String }

  preview() {
    const expression = this.expressionTarget.value.trim()

    if (!expression) {
      this.showError(i18n.t('field_preview.enter_expression_first'))
      return
    }

    this.setLoading(true)

    fetch(this.urlValue, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'Accept': 'text/vnd.turbo-stream.html',
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.content
      },
      body: new URLSearchParams({ expression })
    })
      .then(response => {
        if (!response.ok) throw new Error('Network response was not ok')
        return response.text()
      })
      .then(html => {
        Turbo.renderStreamMessage(html)
      })
      .catch(error => {
        this.showError(i18n.t('field_preview.error_previewing_with_message', { error: error.message }))
      })
      .finally(() => {
        this.setLoading(false)
      })
  }

  setLoading(loading) {
    if (this.hasPreviewButtonTarget) {
      this.previewButtonTarget.disabled = loading
      if (loading) {
        this.previewButtonTarget.innerHTML = `
          <span class="loading loading-spinner loading-xs mr-1"></span>
          ${i18n.t('field_preview.testing')}
        `
      } else {
        this.previewButtonTarget.innerHTML = `
          <svg class="w-3 h-3 mr-1"><use href="#eye-icon"></use></svg>
          ${i18n.t('field_preview.test_expression')}
        `
      }
    }
  }

  showError(message) {
    if (this.hasPanelTarget) {
      this.panelTarget.innerHTML = `
        <div class="bg-base-200 rounded-lg p-4 mt-4">
          <div class="alert alert-error text-sm">
            <span>${message}</span>
          </div>
        </div>
      `
    }
  }
}
